import { useState } from 'react';
import { Popover } from 'shared-ui';

import { ReactComponent as DropdownIcon } from 'assets/icons/dropdown.svg';
import { ReactComponent as RemoveIcon } from 'assets/icons/remove.svg';
import { useLocale } from 'hooks/useLocale/useLocale';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import * as Styled from '../Table.styles';

import { HeaderFilterItemProps } from './HeaderMultiFilterItem.types';

const HeaderMultiFilterItem = <T extends string>({
  filterItems,
  queryKey,
  queryName,
  queryHeader,
  queryHeaderDescriptions,
}: HeaderFilterItemProps<T>) => {
  const { formatMessage } = useLocale();
  const [headerFilterEl, setHeaderFilterEl] = useState<HTMLDivElement | undefined>(undefined);

  const {
    storedQueries: { [queryKey]: storedQuery },
    setQuery,
  } = useLocaleStoreQuery();

  const header =
    storedQuery[queryName as keyof typeof storedQuery] && queryHeaderDescriptions
      ? formatMessage({ id: queryHeaderDescriptions[storedQuery[queryName as keyof typeof storedQuery]] })
      : queryHeader;

  const checkedItems = (storedQuery[queryName as keyof typeof storedQuery] || []) as T[];

  return (
    <Styled.TableHeaderItem>
      <Styled.TableHeaderItemSortable
        data-testid={`filter-${queryName}`}
        $isActive={!!headerFilterEl}
        onClick={(e) => setHeaderFilterEl(e.currentTarget)}
      >
        <Styled.TableHeaderItemTextMaxWidth noWrap variant="body2">
          {checkedItems.length ? checkedItems.join(', ') : header}
        </Styled.TableHeaderItemTextMaxWidth>

        {checkedItems.length ? (
          <RemoveIcon
            onClick={(e) => {
              e.stopPropagation();

              setQuery(queryKey, {
                ...storedQuery,
                [queryName]: undefined,
              });
            }}
          />
        ) : (
          <DropdownIcon />
        )}
      </Styled.TableHeaderItemSortable>

      <Popover
        type="filter"
        anchorEl={headerFilterEl}
        onClose={() => setHeaderFilterEl(undefined)}
        filterItems={filterItems}
        multiSelect={{ checkedItems }}
        onClickFilter={(filter) => {
          setQuery(queryKey, {
            ...storedQuery,
            [queryName as keyof typeof storedQuery]: checkedItems.includes(filter)
              ? checkedItems.filter((element) => element !== filter)
              : [...checkedItems, filter],
          });
        }}
      />
    </Styled.TableHeaderItem>
  );
};

// eslint-disable-next-line import/no-default-export
export default HeaderMultiFilterItem;
